import React from 'react';

const App4 = () => (
    <div>
        <h2>Приложение 4</h2>
        <p>Содержание приложения 4...</p>
    </div>
);

export default App4;